angular
    .module('app')
    .factory('RouteService', function ($browser, UserDetailsApi) {
    let fac = {
        buildRoute: buildRoute
    };
    function buildRoute(dest) {
        return UserDetailsApi.get().then(function (user) {
            let role = user.Role;
            let baseHref = $browser.baseHref();
            let route = [baseHref, role, '#/', dest].join('');
            return route;
        });
    }
    return fac;
});
